import { render, staticRenderFns } from "./InterfaceSideMenu.vue?vue&type=template&id=47267a39&scoped=true&"
import script from "./InterfaceSideMenu.vue?vue&type=script&lang=js&"
export * from "./InterfaceSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceSideMenu.vue?vue&type=style&index=0&id=47267a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47267a39",
  null
  
)

export default component.exports